var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/EstimationFilled.tsx";
import React from 'react';
import { createSvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EstimationFilled = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("rect", {
    opacity: "0.05",
    width: "24",
    height: "24",
    rx: "4",
    fill: "#000335"
  }), /*#__PURE__*/_jsx("path", {
    opacity: "0.5",
    d: "M12.787 12.787C12.3463 13.2277 11.6458 13.2277 11.213 12.7949V12.787C10.7801 12.3542 10.7801 11.6537 11.213 11.2209V11.213C11.6458 10.7801 12.3463 10.7801 12.7791 11.213H12.787C13.2199 11.6458 13.2199 12.3542 12.787 12.787ZM12 7.27791L13.6685 8.94638L15.636 6.97885L13.1176 4.4604C12.5037 3.84653 11.5042 3.84653 10.8903 4.4604L8.37186 6.97885L10.3394 8.94638L12 7.27791ZM7.27791 12L8.94638 10.3315L6.97885 8.36399L4.4604 10.8824C3.84653 11.4963 3.84653 12.4958 4.4604 13.1097L6.97885 15.6281L8.94638 13.6606L7.27791 12ZM16.7221 12L15.0536 13.6685L17.0211 15.636L19.5396 13.1176C20.1535 12.5037 20.1535 11.5042 19.5396 10.8903L17.0211 8.37186L15.0536 10.3394L16.7221 12ZM12 16.7221L10.3315 15.0536L8.36399 17.0211L10.8824 19.5396C11.4963 20.1535 12.4958 20.1535 13.1097 19.5396L15.6281 17.0211L13.6606 15.0536L12 16.7221Z",
    fill: "#000335"
  })]
}), 'EstimationFilled');